import type { MessageValues } from './i18n';
import type { expenseMessages } from './i18n/messages/expenses';

/** A message of `expenseMessages`; a notice is one or more of them, shown as one sentence. */
export interface NoticePart {
  key: keyof typeof expenseMessages.en;
  values?: MessageValues;
}
export type Notice = readonly NoticePart[];

const KEY = 'split.notices';

/**
 * Notices about background work that failed while nobody was looking (the tab was hidden): kept
 * on this device and shown as a toast once the user is back, or on the next app start. They are
 * the signed-in user's, so `resetUserState` clears them.
 */
export function addNotice(notice: Notice): void {
  try {
    localStorage.setItem(KEY, JSON.stringify([...readNotices(), notice]));
  } catch {
    // Storage unavailable: the notice is lost, like the toast would have been.
  }
}

function readNotices(): Notice[] {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? (parsed as Notice[]) : [];
  } catch {
    return [];
  }
}

/** Returns the stored notices and forgets them. */
export function takeNotices(): Notice[] {
  const notices = readNotices();
  clearNotices();
  return notices;
}

export function clearNotices(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
